import { render } from "./ProveedorCardBar.vue?vue&type=template&id=1d00e76f"
import script from "./ProveedorCardBar.vue?vue&type=script&lang=js"
export * from "./ProveedorCardBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__